import { render, staticRenderFns } from "./WhatsAppTermsAmendmentV1.vue?vue&type=template&id=63c8f804&scoped=true&"
import script from "./WhatsAppTermsAmendmentV1.vue?vue&type=script&lang=js&"
export * from "./WhatsAppTermsAmendmentV1.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppTermsAmendmentV1.vue?vue&type=style&index=0&id=63c8f804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8f804",
  null
  
)

export default component.exports